import React from 'react';
import { useNavigate } from 'react-router-dom';

const WorkoutSuccessModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleManageWorkouts = () => {
    navigate('/health/workouts');
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white dark:bg-shoorah-darkBgTabColor rounded-lg p-8 max-w-md w-full mx-4 shadow-xl">
        {/* Success Icon */}
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 rounded-full bg-blue-100 flex items-center justify-center">
            <svg
              className="w-12 h-12 text-blue-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
        </div>

        {/* Title */}
        <h2 className="text-2xl font-semibold text-center text-gray-900 dark:text-white mb-3">
          You've successfully created a workout session
        </h2>

        {/* Description */}
        <p className="text-center text-gray-600 dark:text-gray-300 mb-8">
          You can now manage this workout and access valuable insights
        </p>

        {/* Manage Workouts Button */}
        <button
          onClick={handleManageWorkouts}
          className="btn-primary w-full"
        >
          Manage Workouts
        </button>
      </div>
    </div>
  );
};

export default WorkoutSuccessModal;
